import { TrendingUp, Users, Target } from "lucide-react";
import { BACKGROUND_LEAD } from "../../constants";

export function BackgroundSection() {
  const bulletTexts = [
    "プラットフォームやアルゴリズムの変化に素早く対応する体制づくりが必要です",
    "自社アカウント運用を内製化し、継続的に発信・改善できるスキルが重要です",
    "助成金を活用し、低コストで実践的な制作・運用スキルを定着させます",
  ];

  const featureText =
    "本プログラムでは、厚生労働省の「人材開発支援助成金（リスキリング支援コース）」を活用し、低コストで効果的に必要なスキルを習得できる実践的な研修をご提供します。";

  return (
    <section className="py-20 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl text-gray-900">
            ご推進の背景
          </h2>
          <div className="w-24 h-1 bg-black mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            {BACKGROUND_LEAD}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <TrendingUp className="w-8 h-8 text-black" />
            </div>
            <h3 className="text-xl mb-3 text-gray-900">技術進化の加速</h3>
            <p className="text-gray-600">
              {bulletTexts[0]}
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="w-8 h-8 text-black" />
            </div>
            <h3 className="text-xl mb-3 text-gray-900">人材スキル向上</h3>
            <p className="text-gray-600">
              {bulletTexts[1]}
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Target className="w-8 h-8 text-black" />
            </div>
            <h3 className="text-xl mb-3 text-gray-900">効果的な解決策</h3>
            <p className="text-gray-600">
              {bulletTexts[2]}
            </p>
          </div>
        </div>

        <div className="bg-gray-50 p-8 rounded-xl">
          <h3 className="text-2xl mb-4 text-gray-900">本プログラムの特徴</h3>
          <p className="text-gray-700 text-lg">
            {featureText}
          </p>
        </div>
      </div>
    </section>
  );
}
